import { FC, Suspense, lazy } from "react";
import styles from "./categories.module.css";
import {
  WidgetProps,
  WidgetType } from
"@commons-monorepo/index";
import { CategoriesContext } from "./categories.context";

const CategoriesSkin1 = lazy(() => import("./skins/skin-1/categories-skin-1"));
const CategoriesSkin3 = lazy(() => import("./skins/skin-3/categories-skin-3"));
const CategoriesSkin4 = lazy(() => import("./skins/skin-4/categories-skin-4"));
const CategoriesSkin5 = lazy(() => import("./skins/skin-5/categories-skin-5"));
const CategoriesSkin6 = lazy(() => import("./skins/skin-6/categories-skin-6"));

const Categories: FC<WidgetProps<string[], {}>> = ({
  theme,
  data,
  storeMetadata,
  id,
  type
}) => {
  const { Provider } = CategoriesContext;
  const providerValue = {
    theme,
    data,
    partnerId: storeMetadata?.userNetwork?.urlSummer,
    storeMetadata
  };

  return (
    <Provider value={providerValue}>
      <Suspense>
        <div id={id} className={styles.categoriesContainer}>
          {(type === WidgetType.CATEGORIES_SKIN_1 ||
          type === WidgetType.CATEGORIES_SKIN_2) &&
          <CategoriesSkin1 type={type} />}

          {type === WidgetType.CATEGORIES_SKIN_3 && <CategoriesSkin3 />}
          {type === WidgetType.CATEGORIES_SKIN_4 && <CategoriesSkin4 />}
          {type === WidgetType.CATEGORIES_SKIN_5 &&
          <CategoriesSkin5 fullWidth={theme.templateId === "MADRID"} />}

          {type === WidgetType.CATEGORIES_SKIN_6 && <CategoriesSkin6 />}
        </div>
      </Suspense>
    </Provider>);

};

export default Categories;